<template>
  <img class="filter-icon" src="https://cdn.winwinapp.ru/apps/catalog/public/img/filter.svg" >
</template>

<script>
export default {
  name: 'FiltersIcon',
}
</script>

<style scoped>
.filter-icon {
  padding: 6px;
}
</style>